import { render, staticRenderFns } from "./ProductBulkAddIframe.vue?vue&type=template&id=51f8952a&"
import script from "./ProductBulkAddIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductBulkAddIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports